    import React from 'react';
    import '../../styles/mfw.scss';
    import { Link } from 'react-router-dom';
    
function Mfw2025() {
  const immagini = [
    { image: '/images/MFW2025/Megan.jpg', title: [" Megan Ria X PDF Channel Fashion Show"], className: "" },
    { image: '/images/MFW2025/CamillaClemente.jpg', title: ["Camilla Clemente X SUNNEI Fashion Show"],className: ""},
    { image: '/images/MFW2025/lowrah.jpg', title: ["Lowrah X Philipp Plein Fashion Show"],className: ""},
    { image: '/images/MFW2025/Maddalena.jpg', title: ["Maddalena Svevi X Moschino Fashion Show"],className: ""}
  
  ];
  return (
    <section className="magazine">
      <div className="image-grid">
        {immagini.map((img, index) => (
          <div key={index} className={`image-grid__item ${img.className}`}>
            <Link to={img.link}>
              <img src={img.image} alt={img.title.join(' ')} />
              <h3 className="image-grid__title">
                {img.title.map((line, i) => (
                  <span key={i}>
                    {line}
                    {i < img.title.length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Mfw2025;
